export function ehIE() {
  return /MSIE|Trident\//.test(navigator.userAgent);
}
